/* eslint-disable no-unused-vars */

import { Delete, Get, Post, PostFormData } from "../Request";
export default {
  state: {
    Blogs: [],
    BlogsComment: [],
    siteUser: [],
    webUser: [],
    TotalBlogsComment: 0,
    EditBlog: {},
    selectedRelatedBlogs: [],
    selectedBlog: null,
    OrganizeBlogs: [],
  },
  getters: {
    GetBlogs(state) {
      return state.Blogs;
    },
    OrganizeGetBlogs(state) {
      return state.OrganizeBlogs;
    },
    SelectedBlog(state) {
      return state.selectedBlog;
    },
    GetBlogsComments(state) {
      return state.BlogsComment;
    },
    GetSelectedRelatedBlogs(state) {
      return state.selectedRelatedBlogs;
    },
    GetSiteUser(state) {
      return state.siteUser;
    },
    GetWebUser(state) {
      return state.webUser;
    },
    GetTotalBlogsComment(state) {
      return state.TotalBlogsComment;
    },
    GetEditBlog(state) {
      return state.EditBlog;
    },
  },
  actions: {
    async PublishBlog({ commit }, payload) {
      return PostFormData("Blog/AddBlog", payload).then((res) => {
        return res.data;
      });
    },
    async getSiteUser({ commit }, payload) {
      return Get("User/GetSiteUsers").then((res) => {
        commit("SetSiteUser", res.data);
        return res.data;
      });
    },
    async GetWebUser({ commit }, payload) {
      return Get("User/Getall").then((res) => {
        commit("SetWebUser", res.data);
        return res.data;
      });
    },
    async GetBlogs({ commit }, payload) {
      return Get(
        `Blog/GetBlogsAdmin/${payload.page}?pageSize=${payload.pageSize}&search=${payload.search}&filters=${payload.filters}`
      ).then((res) => {
        commit("SetBlog", res.data.Data.List);
        return res.data.Data;
      });
    },
    async OrganizeGetBlogs({ commit }, payload) {
      return Get(`Blog/GetBlog/1?pageSize=all&search=&filters=`).then((res) => {
        commit("OrganizeSetBlog", res.data.Data.List);
        return res.data.Data;
      });
    },
    async GetBlogsComments({ commit, state }, payload) {
      commit("selectedBlog", payload.Id);
      return Get(
        `Blog/GetBlogComments?search=${payload.search}&isWebApp=true&page=${payload.pageNumber}&pageSize=5&blogId=${payload.Id}`
      ).then((res) => {
        commit("SetBlogComments", res.data.Data);
        return res.data.Data;
      });
    },
    async GetBlogById({ commit }, payload) {
      return Get(`Blog/GetBlogById/${payload}`).then((res) => {
        commit("SetEditBlog", res.data.Data.Blog);
        commit("SetRelatedBlogs", res.data.Data.data);
        return res.data.Data.Blog;
      });
    },
    async EditBlog({ commit }, payload) {
      return PostFormData("Blog/EditBlog", payload).then((res) => {
        return res.data;
      });
    },
    async UploadImage({ commit }, payload) {
      var form = new FormData();
      form.append("File", payload);
      return PostFormData("Blog/UploadBlogImage", form).then((res) => {
        // return process.env.VUE_APP_IMG_URL + res.data.Data;
        return res.data.Data;
      });
    },
    async DeleteImage({ commit }, payload) {
      var form = new FormData();

      form.append("File", payload);
      return PostFormData("Blog/DeleteBlogImage", form).then(() => {});
    },
    async DeleteBlog({ commit }, payload) {
      return Delete(`Blog/DeleteBlog/${payload}`).then((res) => {
        return res.data;
      });
    },
    async DeleteBlogComment({ commit }, payload) {
      return Delete(`Blog/DeleteBlogComment/${payload}`).then((res) => {
        return res.data;
      });
    },
    async FeatureBlogs({ commit }, payload) {
      return Post("Blog/FeatureBlogs", payload).then((res) => {
        return res.data;
      });
    },
    async GetFeaturedBlogs({ commit }, payload) {
      return Get("Blog/GetFeaturedBlog").then((res) => {
        return res.data.Data;
      });
    },
    async SetVisibility({ commit }, payload) {
      return PostFormData("Blog/SetVisibility", payload).then((res) => {
        return res.data;
      });
    },
    async SetVisibilityComments({ commit }, payload) {
      return PostFormData("Blog/SetVisibilityComments", payload).then((res) => {
        return res.data;
      });
    },
    SetRelatedBlog({ commit }, payload) {
      commit("SetRelatedBlog", payload);
    },
    ResetRelatedBlog({ commit }, payload) {
      commit("ResetRelatedBlog", null);
    },
    RemoveRelatedBlog({ commit }, payload) {
      commit("RemoveRelatedBlog", payload);
    },
  },
  mutations: {
    selectedBlog(state, payload) {
      state.selectedBlog = payload;
    },
    SetRelatedBlog(state, payload) {
      state.selectedRelatedBlogs.push(payload);
    },
    SetRelatedBlogs(state, payload) {
      state.selectedRelatedBlogs = payload.map((x) => {
        // x.Banner = process.env.VUE_APP_IMG_URL + "/" + x.Banner;
        return x;
      });
    },
    RemoveRelatedBlog(state, payload) {
      const indexOfItem = state.selectedRelatedBlogs.findIndex(
        (item) => item.Id === payload.Id
      );
      if (indexOfItem !== -1) {
        state.selectedRelatedBlogs.splice(indexOfItem, 1);
      }
    },
    SetBlog(state, payload) {
      state.Blogs = payload.map((e) => {
        // if (e.Banner != "") {
        //   e.Banner = process.env.VUE_APP_IMG_URL + "/" + e.Banner;
        // }
        return e;
      });
    },
    OrganizeSetBlog(state, payload) {
      state.OrganizeBlogs = payload;
    },
    SetBlogComments(state, payload) {
      state.BlogsComment = payload.List.map((e) => {
        // if (e.SubmittedByProfileImage != "") {
        //   e.SubmittedByProfileImage =
        //     process.env.VUE_APP_IMG_URL + "/" + e.SubmittedByProfileImage;
        // }
        return e;
      });
      state.TotalBlogsComment = payload.totalRecords;
    },
    SetSiteUser(state, payload) {
      state.siteUser = payload;
    },
    SetWebUser(state, payload) {
      state.webUser = payload;
    },
    SetEditBlog(state, payload) {
      payload.Content = payload.Content.replace(
        /<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi,
        ""
      );
      payload.Content = payload.Content.replace(/<div[^>]*>/gi, "<p>").replace(
        /<\/div>/gi,
        "</p>"
      );

      let cleanedHtml = payload.Content.replace(/<font[^>]*>/g, "");
      payload.Content = cleanedHtml.replace(/<\/font>/g, "");
      payload.Banner =
        payload.Banner != null &&
        payload.Banner != undefined &&
        payload.Banner != ""
          // ? process.env.VUE_APP_IMG_URL + "/" + payload.Banner
          ? payload.Banner
          : payload.Banner;

      payload.SubmittedByProfileImage =
        payload.SubmittedByProfileImage != null &&
        payload.SubmittedByProfileImage != undefined &&
        payload.SubmittedByProfileImage != ""
          // ? process.env.VUE_APP_IMG_URL + "/" + payload.SubmittedByProfileImage
          ? payload.SubmittedByProfileImage
          : payload.SubmittedByProfileImage;

      state.EditBlog = payload;
    },
    ResetRelatedBlog(state, payload) {
      state.selectedRelatedBlogs = [];
    },
  },
};
